import {
  Box,
  BoxProps,
  Button,
  ColorOptions,
  convertHexToRGBA,
  Loader,
  ModalDialogNew,
  ModBox,
  Spacer,
  Text,
  TextProps
} from '@jfs/ui-new'
import { Colors } from '../../../../../src/util/util'
import { SvgImage } from '../../../../comps/SvgImage'

interface ModelBlockUserProps {
  show: boolean
  onDismiss: () => void
  onPressDone: (action: string) => void
  data: any
  action: any
  status: any
  isLoading: any
}

export const ModelBlockUser = ({ show, onDismiss, onPressDone, ...props }: ModelBlockUserProps) => {
  const actionDataSet: any = {}
  if (props.action === 'BLOCK') {
    actionDataSet.title = 'Are you sure you want to block the user?'
    actionDataSet.buttonText = 'Block User'
    actionDataSet.successMessage = "This user won't be able to access your joint account until you unblock them."
    actionDataSet.successTitle = 'User is now blocked'
    actionDataSet.iconRelative = 'ItemUnChecked'
    actionDataSet.iconAbsolute = 'STOP'
  } else if (props.action === 'UNBLOCK') {
    actionDataSet.title = 'Are you sure you want to unblock the user?'
    actionDataSet.buttonText = 'Unblock User'
    actionDataSet.successMessage = 'This user will be able to access your joint account from now.'
    actionDataSet.successTitle = 'User is now unblocked'
    actionDataSet.iconRelative = 'ItemChecked'
    actionDataSet.iconAbsolute = 'UNBLOCK'
  } else if (props.action === 'DELETE') {
    actionDataSet.title = 'Are you sure you want to delete the user?'
    actionDataSet.buttonText = 'Delete User'
    actionDataSet.successMessage = "This user won't be able to access your profile from now onwards."
    actionDataSet.successTitle = 'User is now deleted'
    actionDataSet.iconRelative = 'DeleteIcon'
    actionDataSet.iconAbsolute = 'DELETE'
  }
  //console.log('block', data)
  return (
    <ModalDialogNew show={show} animate={true} type="bottom" backgroundColor="TRANSPARENT">
      <Box {...styles.container}>
        <ModBox show={props.isLoading} align="center" justify="center" height={250}>
          <Loader type={'small'} color="PRIMARY" />
        </ModBox>
        <ModBox show={!props.isLoading}>
          <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={20}>
            <Box
              width={45}
              height={45}
              borderRadius={45}
              backgroundColor={
                props.action === 'DELETE'
                  ? ('#E30513' as ColorOptions)
                  : props.action === 'UNBLOCK'
                  ? ('#00B259' as ColorOptions)
                  : ('#FA7D19' as ColorOptions)
              }
              align="center"
              justify="center">
              <SvgImage imageName={actionDataSet.iconRelative} color="#fff" />
            </Box>
            <Box onPress={onDismiss} testID="close" underlayColor={'TRANSPARENT'}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>
          <Box height={'auto'}>
            <Box maxWidth={'90%'}>
              <Text {...styles.headerText}>{actionDataSet?.title}</Text>
            </Box>
            <Spacer size={40} direction={'vertical'} />

            <Button isFull isRound testID="btn-action" onPress={() => onPressDone(props.action)} height={48}>
              <Text color="WHITE" fontSize={16} fontFamily="JioType-Bold">
                {actionDataSet.buttonText}
              </Text>
            </Button>
          </Box>
        </ModBox>
      </Box>
    </ModalDialogNew>
  )
}

const styles = {
  container: {
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    backgroundColor: 'WHITE',
    p: 25,
    pt: 30,
  } as BoxProps,
  descText: {
    fontSize: 12,
    fontFamily: 'JioType-Medium',
    color: 'PRIMARY_GREY',
    lineHeight: 20,
  } as TextProps,
  headerText: {
    fontSize: 24,
    fontFamily: 'JioType-Black',
    color: Colors.BLACK_14,
  } as TextProps,
  statusIconBG: (action: string, opacity: number) =>
    ({
      backgroundColor:
        action === 'DELETE'
          ? (convertHexToRGBA('#C94949', opacity) as ColorOptions)
          : (convertHexToRGBA('#62A051', opacity) as ColorOptions),
    } as BoxProps),
  statusIconBorderColor: (action: string, opacity: number) =>
    ({
      borderBottomColor:
        action === 'DELETE'
          ? (convertHexToRGBA('#C94949', opacity) as ColorOptions)
          : (convertHexToRGBA('#62A051', opacity) as ColorOptions),
    } as BoxProps),
}
